var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGatewayChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2067_22581",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 5,
    fill: "#384663"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2067_22581)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 5,
    fill: "#2E3A54"
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.2,
    x1: -3.48195e-9,
    y1: 5.46436,
    x2: 40,
    y2: 5.46436,
    stroke: "#5C73A4",
    strokeWidth: 0.5,
    strokeDasharray: "4 1.2"
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.2,
    x1: -3.48195e-9,
    y1: 11.1787,
    x2: 40,
    y2: 11.1787,
    stroke: "#5C73A4",
    strokeWidth: 0.5,
    strokeDasharray: "4 1.2"
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.2,
    x1: -3.48195e-9,
    y1: 16.8931,
    x2: 40,
    y2: 16.8931,
    stroke: "#5C73A4",
    strokeWidth: 0.5,
    strokeDasharray: "4 1.2"
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.2,
    x1: -3.48195e-9,
    y1: 22.6072,
    x2: 40,
    y2: 22.6072,
    stroke: "#5C73A4",
    strokeWidth: 0.5,
    strokeDasharray: "4 1.2"
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.2,
    x1: -3.48195e-9,
    y1: 28.3213,
    x2: 40,
    y2: 28.3213,
    stroke: "#5C73A4",
    strokeWidth: 0.5,
    strokeDasharray: "4 1.2"
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.2,
    x1: -3.96868e-9,
    y1: 34.0356,
    x2: 40,
    y2: 34.0356,
    stroke: "#5C73A4",
    strokeWidth: 0.5,
    strokeDasharray: "4 1.2"
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.2,
    x1: -3.96868e-9,
    y1: 39.75,
    x2: 40,
    y2: 39.75,
    stroke: "#5C73A4",
    strokeWidth: 0.5,
    strokeDasharray: "4 1.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 20.5C33 27.4036 27.4036 33 20.5 33C13.5964 33 8 27.4036 8 20.5C8 13.5964 13.5964 8 20.5 8C27.4036 8 33 13.5964 33 20.5ZM13.1789 20.5C13.1789 24.5433 16.4567 27.8211 20.5 27.8211C24.5433 27.8211 27.8211 24.5433 27.8211 20.5C27.8211 16.4567 24.5433 13.1789 20.5 13.1789C16.4567 13.1789 13.1789 16.4567 13.1789 20.5Z",
    fill: "#3E4B67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 8C23.0074 8 25.4568 8.75406 27.5301 10.1642C29.6033 11.5744 31.2046 13.5755 32.1258 15.9075L27.309 17.8102C26.7695 16.4444 25.8317 15.2724 24.6174 14.4465C23.4031 13.6206 21.9685 13.1789 20.5 13.1789V8Z",
    fill: "#00CBAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0775 15.787C33.0574 18.1943 33.2626 20.8472 32.6645 23.3766C32.0664 25.9059 30.6947 28.1859 28.7403 29.8993C26.7859 31.6127 24.3461 32.6743 21.7602 32.9363C19.1743 33.1983 16.5711 32.6478 14.3127 31.3613L16.8762 26.8613C18.1989 27.6148 19.7236 27.9372 21.2381 27.7838C22.7526 27.6303 24.1816 27.0085 25.3262 26.005C26.4709 25.0015 27.2743 23.6662 27.6246 22.1848C27.9749 20.7034 27.8547 19.1496 27.2807 17.7397L32.0775 15.787Z",
    fill: "#128D7C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGatewayChart);
export default __webpack_public_path__ + "static/media/gateway-chart.d635164c.svg";
export { ForwardRef as ReactComponent };